export default "__VITE_ASSET__CaSSQuXZ__"